<template>

  <div id="dlnkaap_candidature">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <!-- Hero Section -->
    <div class="gradient-x-three-sm-primary">
      <div class="container space-top-1">
        <h1 class="display-4 text-center my-8">Ils oeuvrent sur le territoire</h1>
        <div class="d-flex justify-content-center mb-4">
          <a class="btn btn-info font-weight-bold" style="font-size: x-large" href="/module/dlnkaap/candidature" role="button">Ajouter son projet</a>
        </div>
        <!-- Card -->
        <div class="card p-2 mb-3">
          <!-- Input Group -->
          <div class="form-row input-group-borderless">
            <div class="col-sm mb-2 mb-md-0">
              <div class="input-group input-group-merge input-group-borderless">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fas fa-search"></i>
                  </div>
                </div>

                <input type="text" class="form-control" placeholder="Alimentaire, autonomie ..." aria-label="Job title, skills, or company">
              </div>
            </div>

            <div class="col-sm d-sm-none">
              <hr class="my-0">
            </div>

            <div class="col-sm column-divider-sm mb-2 mb-md-0">
              <div class="input-group input-group-merge input-group-borderless">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                </div>

                <input type="text" class="form-control" placeholder="Département, ville, code postal" aria-label="City, state, or zip" value="Paris">
              </div>
            </div>

            <div class="col-md-auto my-auto">
              <button type="button" class="btn btn-block btn-primary px-5">Rechercher</button>
            </div>
          </div>
          <!-- End Input Group -->
        </div>
        <!-- End Card -->
      </div>
    </div>
    <!-- End Hero Section -->

    <!-- Listing Section -->
    <div class="container space-1 space-bottom-lg-3">
      <div class="row">
        <div class="bg-soft-primary rounded col-lg-3 order-0 mb-5 mb-lg-0">
          <!-- Navbar -->
          <div class="navbar-expand-lg navbar-expand-lg-collapse-block navbar-light">
            <!-- Responsive Toggle Button -->
            <button type="button" class="navbar-toggler btn btn-block btn-white"
                    aria-label="Toggle navigation"
                    aria-expanded="false"
                    aria-controls="sidebarNav"
                    data-toggle="collapse"
                    data-target="#sidebarNav">
          <span class="d-flex justify-content-between align-items-center">
            <span class="h5 mb-0">Voir tous les filtres</span>
            <span class="navbar-toggler-default">
              <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"/>
              </svg>
            </span>
            <span class="navbar-toggler-toggled">
              <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"/>
              </svg>
            </span>
          </span>
            </button>
            <!-- End Responsive Toggle Button -->

            <div id="sidebarNav" class="collapse navbar-collapse">
              <div class="pt-4 pt-lg-0">
                <!-- Filter Form -->
                <form>
                  <!-- Filter Group -->
                  <div class="my-5">
                    <h6 class="small text-cap">Projet débuté</h6>

                    <!-- Select -->
                    <select class="col-12 px-0 js-select selectpicker dropdown-select"
                            data-style="btn-sm btn-primary">
                      <option value="yesterday">Hier</option>
                      <option value="last_week">Une semaine</option>
                      <option value="last_month">Un mois</option>
                      <option value="last_three_month">Les 3 derniers mois</option>
                      <option value="last_six_month" selected>Les 6 derniers mois</option>
                      <option value="all">Tout voir</option>
                    </select>
                    <!-- End Select -->
                  </div>
                  <!-- End Filter Group -->

                  <!-- Filter Group -->
                  <div class="mb-5">
                    <h6 class="small text-cap">Axes</h6>

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="axe_sante_enfance"
                               v-model="checked_axes">
                        <label class="custom-control-label" for="axe_sante_enfance">Santé et petite enfance</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="axe_famille_jeunesse"
                               v-model="checked_axes">
                        <label class="custom-control-label" for="axe_famille_jeunesse">Famille / Jeunesse</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="axe_insertion_sociale"
                               v-model="checked_axes">>
                        <label class="custom-control-label" for="axe_insertion_sociale">Insertion et action sociale</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="jobTitles5">
                        <label class="custom-control-label" for="jobTitles5">Logement et mixité sociale</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="jobTitles4" checked>
                        <label class="custom-control-label" for="jobTitles4">Autonomie (Handicap et Senior)</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->
                  </div>
                  <!-- End Filter Group -->

                  <!-- Filter Group -->
                  <div class="mb-5">
                    <h6 class="small text-cap">Thématiques </h6>

                    <!-- Checkbox -->
                    <div class="d-flex align-items-center justify-content-between mb-2"
                         v-for="tag in tags" :key="tag.id">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :id="'tag_' + tag.id"
                               v-model="checked_thematiques" :value="tag.id" @change="get_aaps()">
                        <label class="custom-control-label" :for="'tag_' + tag.id">{{tag.nom}}</label>
                      </div>
                    </div>
                    <!-- End Checkbox -->
                  </div>
                  <!-- End Filter Group -->

                  <button type="button" class="btn btn-sm btn-block btn-white" @click="reset_filter()">
                    <i class="fas fa-redo fa-sm mr-1"></i> Réinitialiser
                  </button>
                </form>
                <!-- End Filter Form -->
              </div>
            </div>
          </div>
          <!-- End Navbar -->
        </div>

        <div class="col-lg-9">
          <!-- Title and Sort -->
          <div class="row align-items-sm-center">
            <div class="col-sm mb-3 mb-sm-0">
              <h3 class="mb-0">{{ aaps.length }} projets filtrés</h3>
            </div>
          </div>
          <!-- End Title and Sort -->

          <hr class="my-4">

          <!-- Card -->
          <div v-for="aap in aaps" :key="aap.id" class="card card-bordered card-hover-shadow mb-5">
            <div class="card-body">
              <!-- Media -->
              <div class="d-sm-flex">
                <div class="media align-items-center align-items-sm-start mb-3">
                  <img class="avatar avatar-sm mr-3"
                       :src="aap.logo_structure"
                       alt="Logo du projet">
                </div>

                <div class="media-body">
                  <div class="row justify-content-between">
                    <div class="col col-md-8 mt-1">
                      <h3 class="mb-2">
                        <a class="text-dark" :href="'/module/dlnkaap/appel_crowdfunding?id=' + aap.id ">{{aap.projet_nom}}</a>
                      </h3>
                      <div class="d-none d-sm-inline-block">
                        <h6 class="mb-0">
                          <span class="text-secondary">{{aap.activite_principale|truncate(512) }}</span>
                        </h6>
                      </div>
                    </div>

                    <div class="mt-3 ml-1 mr-1 order-md-3">
                      <h6 class="text-primary"><i class="fa fa-building mr-2" aria-hidden="true"></i>{{aap.nom}}</h6>
                    </div>
                  </div>
                  <!-- End Row -->
                </div>
              </div>
              <!-- End Media -->
            </div>

            <div class="card-footer pt-2 pb-0">
              <div class="d-flex">
                <div>
                  <ul class="list-inline list-separator small text-body">
                    <li class="list-inline-item">Publié le {{ aap.creation_short }}</li>
                    <li class="list-inline-item"><i class="fa fa-circle" aria-hidden="true"></i></li>
                    <!--                    <li class="list-inline-item">Mis en place le 03/21</li>-->
                  </ul>
                </div>
                <div class="ml-auto">
                  <span class="badge badge-soft-info" v-for="tag in aap.tags">
                    {{ tag.nom }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- End Card -->

          <!-- Pagination -->
          <div class="d-flex justify-content-between align-items-center mt-7">
            <nav aria-label="Page navigation">
              <ul class="pagination mb-0">
                <li class="page-item ml-0">
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item disabled"><a class="page-link" href="#">...</a></li>
                <li class="page-item"><a class="page-link" href="#">9</a></li>
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>

            <small class="d-none d-sm-inline-block text-body">Page 1 out of 9</small>
          </div>
          <!-- End Pagination -->
        </div>
      </div>
      <!-- End Row -->
    </div>
    <!-- End Listing Section -->

  </div>

</template>

<script>

export default {
  props: {},
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aaps: Array,
      tags: Array,

      wait_data: true,

      page: 1,
      status_filter: [],
      show_archived: false,
      show_deleted: false,

      checked_thematiques: [],
      checked_axes: [],

    }
  },
  mounted() {
    this.get_data()
  },

  filters: {
    truncate: function(data,num){
      const reqdString =
          data.split("").slice(0, num).join("");
      return reqdString;
    }
  },


  computed: {},

  watch: {},

  methods: {

    close_message: function () {
      this.message = null;
    },

    destroy: async function (id) {
      const _this = this;
      if (confirm("Êtes vous certain de vouloir supprimer cette candidature ?")) {
        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += "aaps/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      }
    },

    get_data: function () {
      this.get_aaps()
      this.get_tags()
    },

    get_tags: async function () {
      let _this = this
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_aaps: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      api_url += '&page=' + _this.page
      api_url += '&archived=' + _this.show_archived
      api_url += '&deleted=' + _this.show_deleted
      api_url += '&status=' + _this.status_filter

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.aaps = response.data.aaps
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.aaps_count = response.data.meta.count
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
              }
          );
    },

    reset_filter: async function () {
      this.checked_thematiques = []
      this.get_aaps()
    },
  }
}

</script>
